
import config from '@/config/index'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { getDetail, getGroupList, getTelephone } from '@/api/pintuan'
export default {
components: { Swiper, SwiperItem, Group, Cell },
data () {
return {
baseUrl: config.baseUrl,
id: this.$route.params.id,
obj: {},
groupList: [],
countDownCont: '',
isGroup: null, // 1已参团2未参团
status: null, // 状态 0-未开始 1-正在进行中 2-结束
telephone: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
mounted () {
this.getDetail()
this.getGroupList()
this.getTelephone()
},
methods: {
getTelephone () {
getTelephone().then(res => {
this.telephone = res.returnValue.telephone
})
},
getDetail () {
getDetail({
accountid: this.accountid,
id: this.id
}).then(res => {
this.obj = res.returnValue
this.countDown(this.obj.startdate, this.obj.enddate)
})
},
getGroupList () {
getGroupList({
accountid: this.accountid,
productid: this.id,
page: 1,
rows: 10
}).then(res => {
this.groupList = res.returnValue.list
this.isGroup = res.returnValue.isGroup
})
},
onBuy (type, groupid) {
this.$router.push({
name: 'pintuanOrder',
params: { id: this.id, type: type, groupid: groupid }
})
},
countDown (startDate, endDate) {
let curDate = new Date()
startDate = new Date(startDate.replace(/-/g, '/'))
endDate = new Date(endDate.replace(/-/g, '/'))
let t1 = (startDate.getTime() - curDate.getTime()) / 1000
if (t1 > 0) {
this.countDownCont = '未开始'
this.status = 0
return false
}
let t = (endDate.getTime() - curDate.getTime()) / 1000
if (t > 0) {
this.status = 1
} else {
this.status = 2
}
let timer = setInterval(() => {
if (t > 0) {
let hour = Math.floor(t / (60 * 60))
let minute = Math.floor(t / 60) - hour * 60
let second = Math.floor(t) - hour * 60 * 60 - minute * 60
hour = hour < 10 ? '0' + hour : hour.toString()
minute = minute < 10 ? '0' + minute : minute.toString()
second = second < 10 ? '0' + second : second.toString()
this.countDownCont = ''
hour.split('').forEach(item => {
this.countDownCont += `<span>${item}</span>`
})
this.countDownCont += '<i>:</i>'
minute.split('').forEach(item => {
this.countDownCont += `<span>${item}</span>`
})
this.countDownCont += '<i>:</i>'
second.split('').forEach(item => {
this.countDownCont += `<span>${item}</span>`
})
} else {
clearInterval(timer)
this.countDownCont = '已结束'
this.status = 2
}
t--
}, 1000)
}
}
}
